module.exports = __webpack_public_path__ + "band_14_son.76dfd98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_14_son.png
// module id = RMD9
// module chunks = 0